import * as apiRoutes from '../../apiRoutes';
import { actionTypes } from "../../actionTypes";
import { APIUrl } from "../../constants";
import * as api from '../../tools/apiMiddleware';
import { toDate, toMoment } from '../../tools/toolkit';

const initialState = {
    isLoading: true, canReturnBack: false
};

export const publicationRightsStore = {
    getPublicationRights: (programmeId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.PublicationRights + `/${programmeId}`;
        await api.getRequest(dispatch, url, actionTypes.GET_PUBLICATION_RIGHTS, actionTypes.GET_PUBLICATION_RIGHTS_SUCCESS, actionTypes.GET_PUBLICATION_RIGHTS_FAIL);

    },
    clearErrorMessage: () => (dispatch, getState) => {

        dispatch({ type: actionTypes.PUBLICATION_RIGHTS_CLEAR_ERROR });

    },
    updateGlobal: (programmeId, isGlobal) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.PublicationRightGlobal + `/${programmeId}/${isGlobal}`;
        await api.updateRequest(dispatch, url, null, actionTypes.UPDATE_PUBLICATION_RIGHT, actionTypes.UPDATE_PUBLICATION_RIGHT_SUCCESS, actionTypes.UPDATE_PUBLICATION_RIGHT_FAIL);

        let data = getState().publicationRights.data;
        data.global = isGlobal;

        let url2 = APIUrl + apiRoutes.PublicationRights + `/${programmeId}`;
        await api.getRequest(dispatch, url2, actionTypes.GET_PUBLICATION_RIGHTS, actionTypes.GET_PUBLICATION_RIGHTS_SUCCESS, actionTypes.GET_PUBLICATION_RIGHTS_FAIL);

    },
    updatePerpetuity: (programmeId, inPerpetuity) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.PublicationRightPerpetuity + `/${programmeId}/${inPerpetuity}`;
        await api.updateRequest(dispatch, url, null, actionTypes.UPDATE_PUBLICATION_RIGHT, actionTypes.UPDATE_PUBLICATION_RIGHT_SUCCESS, actionTypes.UPDATE_PUBLICATION_RIGHT_FAIL);

        let data = getState().publicationRights.data;
        data.inPerpetuity = inPerpetuity === 'true';
    },
    updateTerritory: (programmeId, territory, isBlocked) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.PublicationRightTerritory + `/${programmeId}/${territory}/${isBlocked}`;
        await api.updateRequest(dispatch, url, null, actionTypes.UPDATE_PUBLICATION_RIGHT, actionTypes.UPDATE_PUBLICATION_RIGHT_SUCCESS, actionTypes.UPDATE_PUBLICATION_RIGHT_FAIL);

        let data = getState().publicationRights.data;
        data.rightsTerritories.filter(x => x.countryCode === territory)[0].blocked = isBlocked;
    },
    updateExpiry: (programmeId, date) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.PublicationRightExpiry + `/${programmeId}`;
        await api.updateRequest(dispatch, url, date, actionTypes.UPDATE_PUBLICATION_RIGHT, actionTypes.UPDATE_PUBLICATION_RIGHT_SUCCESS, actionTypes.UPDATE_PUBLICATION_RIGHT_FAIL);

        let data = getState().publicationRights.data;

        if (date) {
            data.expiry = toMoment(date).toDate().toDateString();
        }
        else {
            data.expiry = null;
        }
    },
    updateRestrictions: (programmeId, restrictions) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.PublicationRightRestrictions + `/${programmeId}`;
        await api.updateRequest(dispatch, url, restrictions, actionTypes.UPDATE_PUBLICATION_RIGHT, actionTypes.UPDATE_PUBLICATION_RIGHT_SUCCESS, actionTypes.UPDATE_PUBLICATION_RIGHT_FAIL);

        let data = getState().publicationRights.data;
        data.restrictions = restrictions;
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case actionTypes.GET_PUBLICATION_RIGHTS:
            return {
                ...state,
                data: state.data,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.GET_PUBLICATION_RIGHTS_SUCCESS:
            return {
                ...state,
                data: action.data,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.GET_PUBLICATION_RIGHTS_FAIL:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data
            };
        case actionTypes.PUBLICATION_RIGHTS_CLEAR_ERROR:
            return {
                ...state,
                hasErrorOccured: false
            };
        case actionTypes.UPDATE_PUBLICATION_RIGHT:
            return {
                ...state,
                hasErrorOccured: false
            };
        case actionTypes.UPDATE_PUBLICATION_RIGHT_SUCCESS:
            return {
                ...state,
                hasErrorOccured: false
            };
        case actionTypes.UPDATE_PUBLICATION_RIGHT_FAIL:
            return {
                ...state,
                hasErrorOccured: true,
                errorData: action.data
            };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/NonLinear/PublicationRightsStore.js